module.exports = __webpack_public_path__ + "assets/img/gwcc.8378bed9.svg";